import { useBusinessAccounts } from '../business/scope.js';
import { formatLimit } from '../format-limit.js';
import { AccountPhones } from '../business/phones.js';

export const BusinessAccountsRoute = () => {
  const { accounts, error, refresh } = useBusinessAccounts();
  return <section><header className="page-heading"><div><h1>BMs e números</h1><p>Saúde, limite e ativos exatamente como a Meta informou.</p></div></header>
    {error ? <p role="alert" className="form-error">Não foi possível consultar as contas comerciais.</p> : null}
    <button type="button" className="list-refresh" onClick={refresh}>Atualizar lista de BMs</button>
    {error ? null : accounts === null ? <p className="loading-row">Consultando BMs…</p> : accounts.length === 0 ? <div className="empty-rule">Nenhuma BM conectada.</div> : <div className="ledger-list">{accounts.map((account) => <article className="ledger-row" key={account.id}>
      <div><h2>{account.displayName}</h2><p>{account.status ?? account.health ?? 'Estado não informado'}</p></div>
      <div><span className="field-label">Limite operacional</span><strong>{formatLimit(account.limit ?? { state: 'unreported' })}</strong></div>
      <div><span className="field-label">Última sincronização</span><strong>{account.lastSyncedAt ? new Date(account.lastSyncedAt).toLocaleString('pt-BR') : 'Não informada'}</strong></div>
      <AccountPhones accountId={account.id}/>
    </article>)}</div>}
  </section>;
};
